import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useEffect } from 'react';

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

import fullcolor from './img/productos/fullcolor.png'
import coopermix from './img/productos/coopermix.png'
import powermix from './img/productos/powermix.png'
import termomuro from './img/productos/termomuro.png'
import wallmix from './img/productos/wallmix.png'
import freezermix from './img/productos/freezermix.png'
import duramax from './img/productos/duramax.png'
import infomix from './img/productos/infomix.png'

import lowmix from './img/productos/lowmix.png'

import imagina from './img/imagina-fc.png'
import mmc from './img/mmc.png'

import Velocity from 'velocity-animate';

function App() {

  useEffect(() => {

    let blocks = document.querySelectorAll('.product-block');

    for (let i=0; i<blocks.length;i++) {
      Velocity.animate(blocks[i], { opacity: 1 }, { duration: 250, delay: i*100 });
    }

  }, [])

  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white t-54 pb-3 title-shade">PRODUCTOS DESTACADOS</h3>    
                  </div>

                  <div className="col d-flex flex-row align-items-center pt-3">

                    <Link to="/productos/pisos/coopermix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={coopermix} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Coppermix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

{/*                    <Link to="/productos/vivienda/duramax" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={duramax} style={{maxHeight: '200px'}} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Duramax <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>*/}

{/*                    <Link to="/productos/vivienda/infomix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={infomix} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Infomix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>  */}

                    <Link to="/productos/arquitectonicos/lowmix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={lowmix} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Lowmix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>                    

                    <Link to="/productos/arquitectonicos/fullcolor" relative="path">
                      <div className="product-block d-flex flex-column">
                        <div className="product-block-upper flex-1">
                          <img style={{height: '75%'}} src={fullcolor} />
                        </div>
                        <div className="product-block-bottom">
                          <span className="product-block-bottom-text">Fullcolor <span className="chevron">></span></span>
                        </div>                    
                      </div>
                    </Link>

                    <Link to="/productos/vivienda/freezermix" relative="path" className="d-none">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={freezermix} style={{maxHeight: '200px'}} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Freezermix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                   



                    <Link to="/productos/vivienda/wallmix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={wallmix} style={{padding:'30px'}} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Wallmix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>                    

                    <Link to="/juega" relative="path">
                      <div className="product-block d-flex flex-column" style={{border:'5px solid #f79325', background: 'rgba(0,0,0,0.7)'}}>
                        <div className="product-block-upper flex-1">
                          <img src={imagina} style={{padding:'30px', maxHeight: '200px'}} />
                          <p className="product-block-bottom-text text-center">Imagina con Fullcolor <span className="chevron">></span></p>
                        </div>
                      </div>
                    </Link>

                    <Link to="/mmc" relative="path">
                      <div className="product-block d-flex flex-column" style={{border:'5px solid #f79325', background: 'rgba(0,0,0,0.7)'}}>
                        <div className="product-block-upper flex-1">
                          {<img src={mmc} style={{padding:'30px', maxHeight: '200px'}} />}
                          <p className="product-block-bottom-text text-center">Guía MMC <span className="chevron">></span></p>
                        </div>
                      </div>
                    </Link>                    
                    

                  </div>
                </div>
                
              </div>

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                  
                    <h3 className="text-white t-54 pb-3 title-shade">PRODUCTOS ESPECIALES</h3>

                  </div>

                  <div className="col-11 d-flex flex-row align-items-center pt-3">

                    <div className="row d-flex flex-1">

                      <div className="col-3">
                        <Link to="/productos/resumen" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Resumen de soluciones constructivas<span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-3">
                        <Link to="/productos/vivienda" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Vivienda, Edificación y Productividad<span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-3">
                        <Link to="/productos/arquitectonicos" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Arquitectónicos<span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col-3">
                        <Link to="/productos/pisos" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Pisos, pavimentos y obras civiles<span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                    </div>

                  </div>

                </div>





              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
